export default "__VITE_ASSET__Bbb0yeZN__"